<template>
    <div id="order">
        <div class="lh-header">
            <van-icon name="arrow-left" @click="onClickLeft" class="lh-backicon" />
            <input class="sershop" placeholder="请输入要搜索的产品名称" type="text" v-model="value">
            <van-icon @click="onSearch" class="sericon" name="search" />
        </div>
        <div v-if="show" class="myorder-panel">
            <van-tabs swipeable @change="hactive($event)" v-model="active" animated color="#D61B0A"
                title-inactive-color="#656565" title-active-color="#000">
                <van-tab v-for="item in panelList" :key="item.id" :to="{
                    name: 'order.list',
                    params: { active: item.id },
                }">
                    <template #title>{{ item.name }}</template>
                    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                        <keep-alive>
                            <router-view :gotoWorkOrder="gotoWorkOrder" v-if="$route.meta.keepAlive" />
                        </keep-alive>
                        <router-view :gotoWorkOrder="gotoWorkOrder" v-if="!$route.meta.keepAlive" />
                    </van-pull-refresh>
                </van-tab>
            </van-tabs>
        </div>
        <div v-else>
            <shopnull />
        </div>
    </div>
</template>

<script>
    import api from '../Api'
    export default {
        mixins: [api],
        data() {
            return {
                active: Number(this.$route.params.active),
                value: '', //搜索的值
                panelList: [{
                        id: 0,
                        name: "全部",
                    },
                    {
                        id: 1,
                        name: "待付款",
                    },
                    {
                        id: 2,
                        name: "待发货",
                    },
                    {
                        id: 3,
                        name: "待收货",
                    },
                ],
                orderItemList: [],
                show: true,
                isLoading: false
            };
        },
        mounted() {

        },
        methods: {
            onRefresh() {
                setTimeout(() => {
                    this.isLoading = false;
                }, 1000);
            },
            goback() {

            },
            onSearch() {

            },
            hactive(event) {
                this.$router.push({
                    name: "order.list",
                    params: {
                        active: event,
                    },
                });
            },
            gotoWorkOrder() {

            }
        },
        watch: {
            $route(to, from) {
                this.active = Number(this.$route.params.active);
            },
        }
    };
</script>

<style lang="less" scoped>
    #order {
        padding-top: 2.5rem;
    }

    .lh-header {
        background-color: #fff;
        position: fixed;
        top: 0;
        width: 100%;
        height: 2.5rem;
        z-index: 10;
        display: flex;
        align-items: center;
        padding-left: .75rem;
        padding-right: 1.35rem;

        .lh-backicon {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            left: .75rem;
            color: #111111;
            font-size: 1rem;
            cursor: pointer;
        }

        .sershop {
            margin-left: 1.2rem;
            padding-left: 2.2rem;
            border: 1px solid #F3F2F2;
            height: 1.6rem;
            width: 100%;
            border-radius: 1rem;
            background-color: #F3F2F2;
            font-size: .7rem;

            &::placeholder {
                color: #9E9E9E;
            }
        }

        .sericon {
            cursor: pointer;
            position: absolute;
            z-index: 999;
            left: 3.2rem;
            font-size: .8rem;
            color: #9E9E9E;
        }
    }

    /deep/.van-tabs {
        .van-tabs__line {
            width: .85rem;
            height: .1rem;
            bottom: .2rem;
        }

        .van-tabs__nav--line {
            padding-bottom: 0;
        }

        .van-tabs__wrap {
            position: sticky;
            top: 2.5rem;
            z-index: 10;
            height: 2.2rem;
        }

        .van-tab {
            font-size: .7rem;
        }

        .van-tab--active {
            font-weight: 700;
        }

        .van-tab__pane {
            padding: 0.75rem 0;
        }
    }
</style>